<template lang="html">

  <section class="addFundraising">

    <v-stepper v-model="e1">
      <v-stepper-header>
        <v-stepper-step :complete="e1 > 1" step="1">Select Participants</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :complete="e1 > 2" step="2">{{this.massAdjustment == true ? "Enter Adjustments" : "Distribute Fundraising"}}</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="3">Make Payment</v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">

          <v-card
                  class="mb-2"
          >

            <v-layout row wrap >
              <v-flex xs3>
                <v-text-field
                    type="text"
                    v-model="nameSearch"
                    label="First or Last Name Search"
                    prepend-inner-icon="search"
                    solo-inverted
                    clearable
                    flat
                ></v-text-field>
              </v-flex>
              <v-flex>
                <p style="font-weight: bold; text-decoration: underline;">{{this.selected.filter((selected)=>selected != null).length}} Participants Selected</p>
                <v-btn text-center
                       color="primary"
                       @click="selectAllParticipants()"
                >
                  Select All
                </v-btn>

                <v-btn text-center
                       color="primary"
                       @click="buildSelected()"
                >
                  Continue
                </v-btn>
              </v-flex>
              <v-flex xs3></v-flex>
            </v-layout>


          <v-layout row wrap v-for="(participant,index) in sortedParticipants" >
            <v-flex v-if="!participant.disabled" v-show="!participant.hidden" xs12>
              <v-checkbox style="margin-top:0px; "
                          v-model="selected[index]"
                          :value="participant" hide-details>

                <template  slot="label" >


                  <v-flex fluid  style="border-bottom: 1px black solid; ">


                    <v-layout row wrap >



                      <v-flex fluid style="padding: 3px 5px;" >

                        <h1>{{participant.firstName + ' ' + participant.lastName}}</h1>
                      </v-flex>

                      <v-flex fluid style="border: 1px black solid; padding: 3px 5px;" >
                        <span><b>Phone: </b>{{participant.phone}}</span>
                      </v-flex>

                      <v-flex fluid style="border: 1px black solid; padding: 3px 5px;" >
                        <span><b>Email: </b>{{participant.email}}</span>
                      </v-flex>

                      <v-flex fluid style="border: 1px black solid; padding: 3px 5px;">
                        <span><b>Funds Raised: </b>${{participant.totalFundRaised}}</span>
                      </v-flex>

                      <v-flex fluid  style="border: 1px black solid; padding: 3px 5px;">
                        <span><b>Unpaid: </b>${{participant.selectedTripCost - participant.totalPaid - participant.totalFundRaised}}</span>
                      </v-flex>



                    </v-layout>
                  </v-flex>





                </template>
              </v-checkbox>
            </v-flex>


          </v-layout>
            <br/>
</v-card>

          <v-btn text-center
                 color="primary"
                 @click="buildSelected()"
          >
            Continue
          </v-btn>

        </v-stepper-content>

        <v-stepper-content step="2">
          <v-card
                  class="mb-2">

          <v-data-table v-if="showEntries" hide-actions :headers="[

{
                text: 'Name',
                align: 'left',
                value: 'name',
                sortable: false
              },
              {
                text: 'Email',
                align: 'left',
                value: 'email',
                sortable: false
              },
              {
                  text: 'Phone',
                  align: 'left',
                  value: 'phone',
                sortable: false
              },
              {
                  text: 'Amount To Add',
                  value: 'amount',
                sortable: false
              },
              {
                  text: '',
                  value: '',
                sortable: false
              }
          ]" :items="selectedParticipants"
          >
            <template slot="items" slot-scope="props">
              <tr >
                <td>{{ props.item.firstName + ' ' + props.item.lastName }}</td>
                <td class="text-xs-left">{{ props.item.email }}</td>
                <td class="text-xs-left">{{ props.item.phone }}</td>
                <td class="text-xs-left">
                  <v-text-field
                          type="number"
                          value="0"

                          @input="updateTotal"
                          v-model="props.item.fundraisingToApply"
                          prefix="$"
                  ></v-text-field>
                </td>
                <td class="text-xs-left">
                  <v-btn text-center v-if="props.item.fundraisingToApply != null  && (Number(props.item.fundraisingToApply) > 0 || Number(props.item.fundraisingToApply) < 0)"
                         color="primary" fas small
                         @click="applyToAll(props.item.fundraisingToApply)"
                  >
                    Apply To All
                  </v-btn>
                  <p style="color: red" v-else>Amount Required</p>
                </td>

              </tr>
            </template>

          </v-data-table>




            <br/>


          </v-card>

          <v-layout row wrap>
            <v-flex xs4 >
            </v-flex>
            <v-flex xs4 style="border-bottom: 1px solid black; border-top: 1px solid black;">
              <span v-if="massAdjustment"><b>Total Adjustments: </b></span>
              <span v-else><b>Total Fundraising Payment: </b></span>

              <span>${{totalFundraisingToApply}}</span>
            </v-flex>


            <v-flex xs4 >
            </v-flex>



          </v-layout>

          <p v-if="!validFundraisingAmounts" style="color:red">All amount fields are required</p>

          <v-btn text-center
                 color="secondary"
                 @click="e1 = 1"
          >
            Back
          </v-btn>

          <v-btn
                  :disabled="!validFundraisingAmounts"
                  color="primary"
                  @click="e1 = 3"
          >
            Continue
          </v-btn>
        </v-stepper-content>

        <v-stepper-content step="3">

            <payment-form v-if="e1 == 3"
                          v-on:alertUser="(result, message) => {this.$emit('alertUser', result, message);}"
                    v-bind:massFundraising="true" v-bind:massAdjustment="this.massAdjustment"
                    v-bind:maxPayment="totalFundraisingToApply"  v-bind:initialPayment="totalFundraisingToApply"  v-bind:minPayment="totalFundraisingToApply"
                    v-bind:amount="totalFundraisingToApply"
                          v-bind:hidefr="true" v-bind:participant="selectedParticipants"></payment-form>

        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>





    </v-container>

  </section>

</template>

<script lang="js">

    import paymentForm from '../components/PaymentForm'
  export default  {
    name: 'add-fundraising',
    props: [ "massAdjustment"],
      components: {
          paymentForm
      },
    mounted() {
      this.$structuredData.participants.forEach((participant)=>{
        this.participants.push(participant)
      })
    },
    data() {
      return {
          nameSearch: '',
          showEntries: true,
          validFundraisingAmounts: false,
          selected: [],
          selectedParticipants: [],
          participants: [],
          totalFundraisingToApply: 0,
          e1: 0
      }
    },
    methods: {
        selectAllParticipants() {
          this.sortedParticipants.forEach((participant,index)=>{
            console.log('selectAllParticipants', participant, index)
            if(!participant.disabled) {
              this.$set(this.selected, index, participant);
              //this.selected[index] = participant
            }
          })
        },
        applyToAll(amount) {
            for(var i=0; i < this.selectedParticipants.length; i++) {
                this.selectedParticipants[i].fundraisingToApply = amount
            }

            this.showEntries = false;

            // If you like promises better you can
            // also use nextTick this way
            this.$nextTick().then(() => {
                // Add the component back in
                this.showEntries = true;
                this.updateTotal()
            });
        },
        updateTotal() {
            let validEntries = true
            let toReturn = 0
            this.selectedParticipants.forEach((participant)=>{
                toReturn += Number(participant.fundraisingToApply)
                if(participant.fundraisingToApply == null || Number(participant.fundraisingToApply) == 0) {
                    validEntries = false
                }
            })
            this.validFundraisingAmounts = validEntries

            this.totalFundraisingToApply = toReturn.toFixed(2);

        },
        buildSelected() {

            this.selectedParticipants = []
            this.selected.forEach((participant)=>{
                console.log('CHECKING!!!!!!!!!!!!!!!!!!!!!!!!!!!',participant)
                if(participant != null) {
                    participant.fundraisingToApply = null
                    this.selectedParticipants.push(participant)
                }
            })
            this.updateTotal()
            this.e1++
        }
    },
    computed: {
        sortedParticipants () {
            let sortedParts = this.participants.sort(function(a, b){
                if(a.lastName < b.lastName) { return -1; }
                if(a.lastName > b.lastName) { return 1; }
                return 0;
            })

          let query = this.nameSearch

          if(query === null || query === undefined) {
            query = ''
          } else {
            query = query.trim().toLowerCase()
          }


            sortedParts.forEach((part)=>{
              if(query.length > 0 && (part.lastName.toLowerCase().includes(query) || part.firstName.toLowerCase().includes(query))) {
                part.hidden = false
              } else if(query.length === 0) {
                part.hidden = false
              } else {
                part.hidden = true
              }
            })

          return sortedParts


        }
    }
}
</script>

<style scoped lang="scss">
  .trip {

  }
</style>
